import { DuplicateAliasAccount, fetchDuplicateAliasFeeds } from "@/models/repositories";

export const checkForDuplicateAccounts = async ({
  feedIds,
  workspaceId,
}: {
  feedIds: string[];
  workspaceId;
}): Promise<DuplicateAliasAccount[]> => {
  if (!feedIds || feedIds.length === 0 || !workspaceId) {
    return [];
  }
  const aliasFeedAccounts = await fetchDuplicateAliasFeeds({ feedIds, workspaceId });
  const duplicates = [];
  return aliasFeedAccounts
    ?.map((item) => {
      duplicates.push(item.accountId);
      const duplicateCount = duplicates.filter((id) => id === item.accountId).length;
      if (duplicateCount === 2) {
        return item;
      }
      return null;
    })
    ?.filter((item) => item !== null);
};
